import { Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';

import { Configuration } from '../configuration';
import { CompanyLocation, CompanyLocationResponse } from '@bo-client/shared/models/companyLocations';
import { DataShareService } from '@bo-client/shared/services/data-share.service';
import { ConfigService } from '@bo-client/config/config.service';
import { EntityService } from '@bo-client/shared/dynamic-search-serverside/entity-service';
import { map } from 'rxjs/operators';
import { EntityModel } from '@bo-client/shared/models/entityModel';
import { HttpHapService } from '../http/http-hap.service';

@Injectable()
export class CompanyLocationsService implements EntityService {
  baseUrl = '';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(
    protected httpClient: HttpClient,
    @Optional() configuration: Configuration,
    private hapHttpClient: HttpHapService,
    private dataShareService: DataShareService,
    private configService: ConfigService
  ) {}

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }

  loadData(
    tenant: string,
    environment: string,
    page: number,
    size: number,
    filterModel: any,
    columnState: any[]
  ): Observable<{
    content: any[];
    totalElements: number;
  }> {
    const result = columnState
      .filter((item) => item.sort)
      .map((item) => ({ colId: item.colId, sort: item.sort }));

    const dummyFilterModel = {
      filterModel: filterModel,
      sortModel: result
    };

    return this.hapHttpClient.postTyped<{
      content: any[];
      totalElements: number;
    }>(dummyFilterModel, `/companylocations/filter/v2?page=${page}&size=${size}`);
  }

  public patch(id: number, body: CompanyLocation): Observable<any> {
    let headers = this.defaultHeaders;

    // to determine the Accept header
    const httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.patch<CompanyLocation>(
      `${this.configService.getSettings('serverUrl')}/data/companyLocations/${encodeURIComponent(
        String(id)
      )}`,
      body,
      {
        params: {},
        withCredentials: this.configuration.withCredentials,
        headers: headers
      }
    );
  }

  public create(body: CompanyLocation): Observable<any> {
    let headers = this.defaultHeaders;

    // to determine the Accept header
    const httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.post<CompanyLocation>(
      `${this.configService.getSettings('serverUrl')}/data/companyLocations/`,
      body,
      {
        params: {},
        withCredentials: this.configuration.withCredentials,
        headers: headers
      }
    );
  }

  navigateToCreatePage(params: any) {}

  navigateToEditPage(id: any) {}
}
